<template>
  <div class="header-info">
    <ProductName :tag="tag">
      {{ productName }}
      <template #below>{{ productColor }}</template>
      <template #aside>
        <span>
          <WishlistToggle :product="product" :variant="variant" />
        </span>
      </template>
    </ProductName>
    <BazaarVoice :id="product.id" class="mt-1 h-6" show="rating_summary" />
  </div>
</template>

<script setup lang="ts">
import type { Product, Variant } from '@scayle/storefront-nuxt'

const props = defineProps({
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
  variant: {
    type: Object as PropType<Variant>,
    required: false,
    default: undefined,
  },
  productName: {
    type: String as PropType<string>,
    required: true,
  },
  productColor: {
    type: String as PropType<string>,
    required: true,
  },
  viewport: {
    type: String as PropType<'desktop' | 'mobile'>,
    required: true,
  },
})

const { $viewport } = useNuxtApp()

const tag = computed(() => {
  const isMobile = $viewport.isLessThan('lg')

  if (
    (props.viewport === 'desktop' && isMobile) ||
    (props.viewport === 'mobile' && !isMobile)
  ) {
    return HeadlineTag.DIV
  }

  return HeadlineTag.H1
})
</script>
